import _ from 'lodash';
import React from 'react';
import Field from './field';
import autobind from 'autobind-decorator';

const isReallyEmpty = (value) => _.isUndefined(value) || _.isNull(value);

class FormattedField extends Field {
	renderInput () {
		const { fieldKey, dataId, store } = this.props;
		const { valueKey, setFilter } = _.get(store.config, fieldKey);
		const value = this.getValue({ store, fieldKey, dataId, valueKey, setFilter });
		const formattedValue = this.format(value);

		return <div className="row collapse">
			<div className="small-1 large-1 columns">
				<span className="prefix">{ this.prefix }</span>
			</div>

			<div className="small-11 large-11 columns">
				<input type="text" id={ fieldKey } name={ fieldKey } defaultValue={ formattedValue } onBlur={ this.handleBlur } />
			</div>
		</div>;
	}

	@autobind
	handleBlur ({ target }) {
		target.value = this.format(target.value);
		this.handleChange({ target });
	}

	@autobind
	handleChange ({ target }) {
		const { fieldKey: key, dataId: id, store } = this.props;
		const value = target.value;

		store.set({ key, value, id });
	}
}

export default FormattedField;
